import { Box, Skeleton } from '@mui/material';
import { JSX } from 'react';

interface DataGridLoadingStateProps {
  /**
   * Number of rows to render
   * @default 10
   */
  rowNumber?: number;
  /**
   * Height of each row
   * @default 55
   */
  rowHeight?: number;
}

/**
 * Component to render loading state for table (DataGrid)
 * Useful when data is being fetched from the server
 */
const DataGridLoadingState = ({
  rowHeight = 55,
  rowNumber = 10,
}: DataGridLoadingStateProps): JSX.Element => (
  <Box>
    {Array.from({ length: rowNumber }).map((_, index) => (
      <Skeleton key={index} sx={{ mt: 2 }} variant="rectangular" height={rowHeight} />
    ))}
  </Box>
);

export default DataGridLoadingState;
